export default {
  "path": "/demo/text-color-text",
  "meta": {
    "name": "demo-颜色图标文本",
    "title": "ColorText 颜色图标文本",
    "isComponentDoc": true,
    "category": "Text"
  }
};